import React from "react";
import "./Portfolio.css";
import { Container, Col } from "react-bootstrap";
import { Row } from "react-bootstrap";
import Image from "../../assets/Images/group-13.png";
import googlePlayBtn from "../../assets/Images/google-play-badge.png";
import smMobile from "../../assets/Images/group-21.png";
import { connect } from 'react-redux';
import { compose } from 'redux'
import * as actions from '../../Store/Actions/index';
import { withRouter } from 'react-router-dom'
const Portfolio = (props) => {

  const getGooglePlayBooks = () => {
    props.GetBookByInputType('googleBooks')
    props.history.push('/catalogue');
  }

  return (
    <div className="portfolio">
      <Container>
        <h3 >PORTFOLIO</h3>
        <Row>
          <Col md={6}>
            <div className="RectangleBox">
              <img className="lgMobileImg" src={Image} alt = "logo" />
              <div className="text-container2">
                <h6>eBooks</h6>
                <p>
                  Want to read on the go, explore over 30 of our titles on
                  Google play.
                </p>
                <img onClick = {getGooglePlayBooks} src={googlePlayBtn} alt = "logo" />
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className="RectangleBox box2">
              <div className="text-container1">
                <h6>Xamidea App</h6>
                <p>
                  A complete exam-preparation system, driven by artificial
                  intellegence to prepare you for the exams.
                </p>
                <a href = "https://xamidea.in/" rel="noopener noreferrer" target = "_blank">
                  <button className="websiteLink">
                    VIEW WEBSITE
                    <i className="icon dripicons-arrow-thin-right"></i>
                  </button>
                </a>

                <img className="smMobileImg" src={smMobile} alt = "logo" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};


const mapDispatchToProps = dispatch => {
  return{
    GetBookByInputType : (type) => dispatch(actions.GetBookByInputType(type))
  }
}


export default compose(
  withRouter,
  connect(null, mapDispatchToProps)
)(Portfolio);